import { createSlice } from '@reduxjs/toolkit';
import { getSalesByStore } from './thunk';

const initialState = {
  data: null,
  success: null,
  message: null,
};

const Sales = createSlice({
  name: 'sales',
  initialState,
  reducers: {
    reset(state) {
      return {
        ...state,
        success: null,
        message: null,
      };
    },
  },
  extraReducers: {
    [getSalesByStore.fulfilled]: (state, { payload }) => {
      return {
        success: true,
        message: null,
        data: payload.getSalesByStore,
      };
    },
    [getSalesByStore.rejected]: (state, action) => {
      return {
        ...state,
        success: false,
        message: action.error.message,
      };
    },
  },
});
export const { reset } = Sales.actions;
export default Sales.reducer;
